import React from 'react';
import SliderparentingTool from '../swiper/parentingTool'

export default function ({ highlightsfeed, eleRef }) {
    return (

        <section className="slideTemp parenting_tools_slider">
                                <div className="parenting_tools_padd R15_61">
                                    Parenting Tools
                                </div>
                                <div className="main_view_parenting_tool">
                                
                                   <SliderparentingTool page={"dr-carousel-unit"} data={highlightsfeed.data} />
                                </div>
                            </section> 

    )
}